import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const IncentivesList = () => {
  return (
    <ResponsivePage.Body loading={false} error={null}>
      <>{/* TODO */}</>
    </ResponsivePage.Body>
  )
}

export default IncentivesList
